import styled from 'styled-components'


export const StyledServiceModalContent = styled.div`
	font-size: 16px;
	text-align: center;
	font-weight: 300;
`

export const StyledServiceBtnContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`

